import React, { useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import CorporateInformationTable from "./CorporateInformationProfile";
import CorporateModel from "./CorporateModel";
import {
  allLicenceDetails,
  editCorporateDetail,
  editLicenceDetail,
  updateCorporateLicence,
  updateLicenceDetail,
} from "@/api/bid";
import { setAllLicenseInfo } from "@/bidFeature/propertyDetailSlice";
import { insertCorporateLicence } from "@/api/bid";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
const CorporateInfoTable = ({
  handleShow,
  show,
  addLicenseInfo,
  handleSubmit,
  handleClose,
  formData,
  heading,
  setShow,
}) => {
  const dispatch = useDispatch();
  const [editData, setEditData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleEdit = async (id) => {
    trackButtonClick({
      eventName: "bid_license_edit_click",
      eventCategory: "Profile-Forms Bid/Offer wizard",
      eventLabel: `${id} | Agent | editCorporateLicense`,
      eventSource: "on edit license button click",
      eventParams: { license_id: id, license_type: "agent", license_scope: "corporate" },
    })

    try {
      const response = await editCorporateDetail(id);

      if (response?.status === 200) {
        // Format the data to match your form structure
        const formattedData = {
          affiliatedCompany: response?.data?.data.company,
          agentLicenseState: response?.data?.data?.state,
          licenceNumber: response?.data?.data?.licenseNumber,
          licenceExpiryDate: response?.data?.data?.expiryDate,
          address1: response?.data?.data?.address1,
          address2: response?.data?.data?.address2,
          city: response?.data?.data?.city,
          zipcode: response?.data?.data?.zip,
          status: response?.data?.data?.status,
          licenceId: response?.data?.data?.licenseId,
          state:response?.data?.data?.stateId
        };
        setEditData(formattedData);
        setShow(true);
      }
    } catch (error) {
      console.error("Error fetching licence details:", error);
      // Add error notification here
    }
  };
  const handleFormSubmit = async (data) => {
    // This should only handle new license insertions
    setIsLoading(true);

    try {
      const response = await insertCorporateLicence(data);
      if (response?.data?.status === "SUCCESS") {
        trackApiCall({
          eventName: "bid_license_add_click_success",
          eventCategory: "Profile-Forms Bid/Offer wizard",
          eventLabel: "Agent",
          eventSource: "on add license success",
          eventParams: { license_type: "agent", license_scope: "corporate" }
        })

        const updatedLicenses = await allLicenceDetails();
        setShow(false);

        dispatch(
          setAllLicenseInfo({
            response: {
              CORP: updatedLicenses?.response?.CORP || [],
              INDV: updatedLicenses?.response?.INDV || [],
            },
          })
        );
         toast.success("License Added Successfully")
      }else{
 if (response?.data?.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
  toast.error("Provided zip code is not valid for selected state");
                      // setShowStateLicenseError(
                      //   "Provided zip code is not valid for selected state"
                      // );
                    } else {
                      if(response?.data?.errorMessage==="STATE_LICENSE_ALREADY_EXIST")
                      toast.error("A Corp License already exists for that state. You are allowed to only one Corp License for a State");
                      // setShowModal(false);
                    }
      }
    } catch (error) {
      console.error("Error adding license:", error);
      // alert("Error adding license. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  const handleEditSubmit = async (updatedData) => {
    try {
      const payload = {
        ...updatedData,
        licenceId: editData.licenceId, // Ensure licenceId is included
      };
      const response = await updateCorporateLicence(payload);
      if (response?.status === 200 && response?.data?.status === "SUCCESS") {
        trackApiCall({
          eventName: "bid_license_update_click_success",
          eventCategory: "Profile-Forms Bid/Offer wizard",
          eventLabel: "Agent",
          eventSource: "on edit license success",
          eventParams: { license_id: editData?.licenceId, license_type: "agent", license_scope: "corporate" }
        })

        const updatedLicenses = await allLicenceDetails();
        if (updatedLicenses?.response?.INDV) {
          // Preserve the existing structure when dispatching
          dispatch(
                  setAllLicenseInfo({
                    response: {
                      CORP: updatedLicenses?.response?.CORP || [],
                      INDV: updatedLicenses?.response?.INDV || [],
                    },
                  })
                );
        }
        setEditData(null);
        setShow(false);
      } else {
        console.error("Update failed:", response);
        // alert("Failed to update license. Please try again.");
      }
    } catch (error) {
      console.error("Error updating licence:", error);
      // alert("Error updating license. Please try again.");
    }
  };

  return (
    <div className="license-info">
      <Row className="d-flex justify-content-between align-items-center">
        <Col sm="auto">
          <h4 className="required-label bid-add-license-heading">{heading}</h4>
        </Col>
        <Col sm="auto">
          <Button
            variant="primary"
            className="bid-add-license-btn"
            onClick={handleShow}
          >
            Add License
          </Button>
          <br></br>
        </Col>
        <CorporateInformationTable
          // corporateTableInfoData={corporateTableInfoData}
          handleShow={handleShow}
          show={show}
          onEdit={handleEdit}
          addLicenseInfo={addLicenseInfo}
          setShow={setShow}
        />
      </Row>
      <CorporateModel
        show={show}
        handleClose={() => {
          setShow(false);
          setEditData(null);
        }}
        addLicenseInfo={addLicenseInfo}
        handleSubmit={editData ? handleEditSubmit : handleFormSubmit}
        formData={editData || formData}
        editData={editData}
        isEditing={!!editData}
        // corporateSetTableInfoData={corporateSetTableInfoData}
      />
    </div>
  );
};

export default CorporateInfoTable;
